import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RecipeTemplate } from "../services/backendTypes";

export interface RecipeCreationState {
  activeRecipeTemplate: RecipeTemplate | null;
  recipeTemplateId: number | null;
}

const initialState: RecipeCreationState = {
  activeRecipeTemplate: null,
  recipeTemplateId: null,
};

const recipeCreationSlice = createSlice({
  name: "recipeCreation",
  initialState,
  reducers: {
    setActiveRecipeTemplate: (state, action: PayloadAction<RecipeTemplate>) => {
      state.activeRecipeTemplate = action.payload;
      state.recipeTemplateId = action.payload.id || null;
    },
    clearActiveRecipeTemplate: (state) => {
      state.activeRecipeTemplate = null;
      state.recipeTemplateId = null;
    },
    updateActiveRecipeTemplateId: (state, action: PayloadAction<number>) => {
      state.recipeTemplateId = action.payload;
    },
  },
});

export const { setActiveRecipeTemplate, clearActiveRecipeTemplate, updateActiveRecipeTemplateId } =
  recipeCreationSlice.actions;
export default recipeCreationSlice.reducer;

// Selectors
export const selectActiveRecipeTemplate = (state: { recipeCreation: RecipeCreationState }): RecipeTemplate | null =>
  state.recipeCreation.activeRecipeTemplate;
export const selectRecipeTemplateId = (state: { recipeCreation: RecipeCreationState }): number | null =>
  state.recipeCreation.recipeTemplateId;
